/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsEsportsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-esports"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.35 19.75Q2.88 19.75 1.96 18.57Q1.05 17.4 1.25 15.85L2.3 8.3Q2.52 6.58 3.85 5.41Q5.17 4.25 6.95 4.25L17.05 4.25Q18.82 4.25 20.14 5.41Q21.45 6.58 21.7 8.3L22.75 15.85Q22.95 17.35 22.05 18.55Q21.15 19.75 19.68 19.75Q19.02 19.75 18.43 19.5Q17.82 19.25 17.38 18.8L15.22 16.7L8.8 16.7L6.65 18.8Q6.2 19.25 5.6 19.5Q5 19.75 4.35 19.75ZM17.15 13.15Q17.15 13.15 17.4 13.15Q17.65 13.15 18 12.8Q18.35 12.45 18.35 11.95Q18.35 11.45 18 11.1Q17.65 10.75 17.15 10.75Q16.65 10.75 16.3 11.1Q15.95 11.45 15.95 11.95Q15.95 12.45 16.3 12.8Q16.65 13.15 17.15 13.15ZM15.05 10.1Q15.05 10.1 15.3 10.1Q15.55 10.1 15.9 9.75Q16.25 9.4 16.25 8.9Q16.25 8.4 15.9 8.05Q15.55 7.7 15.05 7.7Q14.55 7.7 14.2 8.05Q13.85 8.4 13.85 8.9Q13.85 9.4 14.2 9.75Q14.55 10.1 15.05 10.1ZM7.45 11.4L7.45 12.2Q7.45 12.6 7.72 12.88Q8 13.15 8.4 13.15Q8.8 13.15 9.07 12.88Q9.35 12.6 9.35 12.2L9.35 11.4L10.15 11.4Q10.55 11.4 10.82 11.13Q11.1 10.85 11.1 10.45Q11.1 10.05 10.82 9.78Q10.55 9.5 10.15 9.5L9.35 9.5L9.35 8.7Q9.35 8.3 9.07 8.03Q8.8 7.75 8.4 7.75Q8 7.75 7.72 8.03Q7.45 8.3 7.45 8.7L7.45 9.5L6.65 9.5Q6.25 9.5 5.97 9.78Q5.7 10.05 5.7 10.45Q5.7 10.85 5.97 11.13Q6.25 11.4 6.65 11.4Z" fill={color} />
    </svg>
  );
}
